import React, { useState } from 'react';
import { routes } from 'constants/config';
import addModifiers from 'utils/add_modifiers';
import request from 'utils/request_ajax';

const CreateOrEditCriteriaBody = ({
  criterion,
  toggleModalState,
  setCriterionNotification,
  updateEditedCriterion,
  removeDeletedCriterion,
}) => {
  const [error, setError] = useState('');
  const [name, setName] = useState(criterion?.name || '');
  const [description, setDescription] = useState(criterion?.description || '');

  const handleNameChange = e => {
    setName(e.target.value);
  };

  const handleDescriptionChange = e => {
    setDescription(e.target.value);
  };

  const handleRequestSuccess = message => {
    toggleModalState();
    setCriterionNotification(message);
  };

  const handleRequestFailure = (data, requestType) => {
    let newError;

    if (data.responseJSON) {
      [newError] = data.responseJSON.error.name; //confirm how this is set from name
    } else if (requestType === 'delete') {
      newError = t(
        'feedback_criteria.custom_criterion.modal.edit.error.on_delete',
      );
    } else {
      newError = t('feedback_criteria.custom_criterion.modal.error.on_save');
    }

    setError(newError);
  };

  const criterionData = () => ({
    custom_criterion: {
      name,
      description,
    },
  });

  const saveCriterion = () => {
    request
      .postJSON(routes.FEEDBACK_CRITERIA.CUSTOM_CRITERION, criterionData())
      .then(data => {
        handleRequestSuccess(data.message);
      })
      .fail(data => {
        handleRequestFailure(data);
      });
  };

  const editCriterion = id => {
    request
      .putJSON(
        routes.FEEDBACK_CRITERIA.CUSTOM_CRITERION + '/' + id,
        criterionData(),
      )
      .then(data => {
        updateEditedCriterion(criterionData(), id);
        handleRequestSuccess(data.message);
      })
      .fail(data => {
        handleRequestFailure(data);
      });
  };

  const deleteCriterion = criterionToDelete => {
    request
      .delete(
        routes.FEEDBACK_CRITERIA.CUSTOM_CRITERION + '/' + criterionToDelete.id,
      )
      .then(data => {
        removeDeletedCriterion(criterionToDelete);
        handleRequestSuccess(data.message);
      })
      .fail(data => {
        handleRequestFailure(data, 'delete');
      });
  };

  const setModalDescription = () => {
    if (criterion) {
      return (
        <div>
          <span className="fw-b mr-4">{t('common.warning')}:</span>
          {t('feedback_criteria.custom_criterion.modal.edit.warning')}
        </div>
      );
    }

    return t('feedback_criteria.custom_criterion.modal.create.description');
  };

  const inputClasses = 'NewInput NewInput--white NewInput--fw NewInput--tall';
  const isEditing = !!criterion;
  const modalTitle = isEditing
    ? t('feedback_criteria.custom_criterion.modal.edit.title')
    : t('feedback_criteria.custom_criterion.modal.create.title');
  const buttonText = isEditing
    ? t('feedback_criteria.custom_criterion.modal.edit.save_button')
    : t('feedback_criteria.custom_criterion.modal.create.button');

  return (
    <div>
      <div className="ModalTakeover-title mb-16">{modalTitle}</div>
      <div className="AddCriteriaModal-newCriterionDescription mb-24 c-brand-gray-darkest">
        {setModalDescription()}
      </div>
      <div>
        <div className="fz-bigger mb-8">{t('common.name')}</div>
        <input
          className={`fz-bigger AddCriteriaModal-nameInput ${inputClasses}`}
          placeholder={t(
            'feedback_criteria.custom_criterion.modal.name_placeholder',
          )}
          type="text"
          onChange={handleNameChange}
          value={name}
        />
      </div>
      <div className="AddCriteriaModal-descriptionInput mt-24">
        <div className="fz-bigger mb-8">{t('common.description')}</div>
        <textarea
          className={inputClasses}
          onChange={handleDescriptionChange}
          placeholder={t(
            'feedback_criteria.custom_criterion.modal.description_placeholder',
          )}
          value={description}
        />
      </div>
      {error && <div className="ErrorContainer fz-bigger mt-32">{error}</div>}
      <div className={`d-f mt-32 ai-c ${isEditing ? 'jc-sb' : 'jc-e'}`}>
        {isEditing && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <div
            className={`${addModifiers('NewButton', [
              'tallAndWide',
              'white',
            ])} deleteCriterionButton`}
            onClick={() => deleteCriterion(criterion)}
          >
            {t('feedback_criteria.custom_criterion.modal.edit.delete_button')}
          </div>
        )}
        <div className="d-f ai-c">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <div
            className="cancelButton c-brand-blue c-p h-td-u fz-bigger mr-24"
            onClick={() => toggleModalState(null)}
          >
            {t('common.cancel')}
          </div>
          <button
            type="button"
            onClick={
              isEditing ? () => editCriterion(criterion.id) : saveCriterion
            }
            className={addModifiers('NewButton', ['tallAndWide', 'blue'])}
            disabled={name === ''}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateOrEditCriteriaBody;
